import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Open Sans, sans-serif', // Set the font-family to Open Sans
  },
});

export default theme;
